<template>
  <div>
    <div v-if="getToken">{{ this.$router.push("/balance") }}</div>
    <div v-else>
      <div class="container-center animated fadeIn">
        <div class="text-center">
          <i class="fad fa-mailbox fa-5x text-accent"></i>
          <h3>New Password Sent</h3>
        </div>
        <div class="panel panel-filled">
          <div class="panel-body">
            <p>
              We've sent you an email detailing your new password. Please follow
              the instructions in the email.
            </p>
            <p class="text-accent text-center font-bold">
              Go to email and get new password
            </p>
            <p>If you haven't received the email, please try the following</p>
            <ul>
              <li>Make sure the email address you provided is correct.</li>
              <li>Check your Spam or Junk mail folders.</li>
              <li>Add 365stream to your email address whitelist.</li>
              <li>Make sure your email is functioning normally.</li>
            </ul>
            <p class="m-t-md">
              <router-link to="/signin"
                ><button class="btn btn-accent btn-block text-accent">
                  Log In
                </button></router-link
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: mapGetters(["getToken"])
};
</script>
